module.exports = __webpack_public_path__ + "static/media/BFSERIESIMAGE.b077c2cb.png";